import isUndefined from 'lodash/fp/isUndefined';
import type { RootDispatch, RootState } from '../../configuration/setup/store';
import { selectOrderedWaypoints } from '../../store/search/searchSelectors';
import { waypointsChanged } from '../../store/search/searchSlice';
import { mapItineraryIntoWaypoints } from './itineraryMapper';
import { selectCurrentTour, selectItinerary } from '../../store/tour/tourSelectors';

export const updateItineraryWaypoints = (dispatch: RootDispatch, getState: () => RootState) => {
    const currentWaypoints = selectOrderedWaypoints(getState());
    const itinerary = selectItinerary(getState());
    const tour = selectCurrentTour(getState());
    const initialCargoWeight = tour?.departure.initialCargoWeight;

    if (isUndefined(itinerary)) {
        throw new Error('Invalid itinerary');
    }

    const waypoints = mapItineraryIntoWaypoints(itinerary, currentWaypoints, initialCargoWeight, tour?.waypoints);
    dispatch(waypointsChanged({ waypoints }));
};
